import * as i0 from '@angular/core';
import { Directive, EventEmitter, Component, Attribute, Input, ViewChild, ViewChildren, Output, HostListener, forwardRef, NgModule } from '@angular/core';
import * as i1 from '@angular/platform-browser';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ARROW_DOWN, ARROW_UP, TAB, ESCAPE, ENTER, SPACE, ARROW_LEFT, ARROW_RIGHT, END, HOME } from '@anthem/uxd/util';
import { Subject } from 'rxjs/internal/Subject';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';

//istanbul ignore next
class ButtonDropdownItemDirective {
    constructor(_eleRef, _renderer) {
        this._eleRef = _eleRef;
        this._renderer = _renderer;
    }
    /**
     * adds active class to 'this._eleRef.nativeElement'
     * adds focus to 'this._eleRef.nativeElement'
     */
    setActive() {
        this._renderer.addClass(this._eleRef.nativeElement, 'active');
        this._eleRef.nativeElement.focus();
    }
    /**
     * removes active class from 'this._eleRef.nativeElement'
     */
    unsetActive() {
        this._renderer.removeClass(this._eleRef.nativeElement, 'active');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ButtonDropdownItemDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: ButtonDropdownItemDirective, selector: "[data-dropdown-menu-item]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ButtonDropdownItemDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[data-dropdown-menu-item]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; } });

// TODO: Remove obsolete code
//istanbul ignore next
class ButtonDropDownComponent {
    /**
     * @param btnCssClass
     * @param id
     * @param _eleRef
     * @param _renderer
     * @param _sanitizer
     */
    constructor(btnCssClass, id, _eleRef, _renderer, _sanitizer) {
        this.btnCssClass = btnCssClass;
        this.id = id;
        this._eleRef = _eleRef;
        this._renderer = _renderer;
        this._sanitizer = _sanitizer;
        this.highlightFirstOption = true;
        this.dropdownOpened = false;
        this.onChange = new EventEmitter();
    }
    /**
     * ensures the dropdown has an ID set
     */
    ngOnInit() {
        this.dropdown.id = this.id || this.dropdown.id;
        if (!this.dropdown.id) {
            console.error("ButtonDropDownComponent id missing !!!");
        }
    }
    ngAfterViewInit() {
        if (this.btnCssClass) {
            this._renderer.addClass(this.mainBtn.nativeElement, this.btnCssClass);
        }
    }
    ngOnChanges(changes) {
        // changes
    }
    /**
     * @param value: SafeUrl
     * @returns a sanitized url
     */
    sanitizeHref(value) {
        return this._sanitizer.bypassSecurityTrustUrl(value || "javascript:void(0)");
    }
    onSelectedChange(value) {
        this.onChange.emit(value);
    }
    /**
     * on click, calls open or close button dropdown methods based on if
     * 'this.dropdownOpened' is true or false
     * @param event
     */
    onButtonClick(event) {
        if (this.dropdownOpened) {
            this.closeDropdown();
        }
        else {
            this.openDropdown();
            if (this.items.length && this.dropdownOpened) {
                this.setNextItemSelected(-1);
            }
        }
    }
    onButtonFocusout(event) {
        this.closeDropdown();
        //this.unSelectAllItems();
    }
    onButtonKeydown(event) {
        let key = event.which || event.keyCode;
        switch (key) {
            case 38: // up
                if (this.dropdownOpened) {
                    //this.setPrevItemSelected();
                }
                event.preventDefault();
                return false;
            case 40: // down
                if (this.dropdownOpened) {
                    //this.setNextItemSelected();
                }
                event.preventDefault();
                return false;
            case 27: // esc
                this.closeDropdown();
                event.preventDefault();
                return false;
            default:
                return true; // exit this handler for other keys
        }
    }
    onDocumentClick(event) {
        if (event.target !== this._eleRef.nativeElement &&
            !this._eleRef.nativeElement.contains(event.target) &&
            this.dropdownOpened) {
            this.closeDropdown();
        }
    }
    /**
     * @param event
     * @param index
     * @param title
     */
    onItemKeydown(event, index, title) {
        let key = event.which || event.keyCode;
        switch (key) {
            case 38: // up
                if (this.dropdownOpened) {
                    this.setPrevItemSelected(index);
                }
                event.preventDefault();
                return false;
            case 40: // down
                if (this.dropdownOpened) {
                    this.setNextItemSelected(index);
                }
                event.preventDefault();
                return false;
            case 27: // esc
                this.closeDropdown();
                event.preventDefault();
                return false;
            case 9: // tab
                if (index + 1 === this.items.length || index === 0) {
                    this.closeDropdown();
                }
                return true;
            default:
                return true; // exit this handler for other keys
        }
    }
    onItemClick(value, label, index) {
        this.onChange.emit(value);
        this.closeDropdown();
        return true;
    }
    setNextItemSelected(currentIndex) {
        this.unSelectAllItems();
        if (this.items.length <= currentIndex + 1) {
            this.items.first.setActive();
        }
        else if (!this.dropdown.defaultHighlight &&
            this.dropdown.defaultHighlight !== undefined) {
            this.items.toArray()[currentIndex + 1].unsetActive();
        }
        else {
            this.items.toArray()[currentIndex + 1].setActive();
        }
    }
    setPrevItemSelected(currentIndex) {
        this.unSelectAllItems();
        if (currentIndex - 1 < 0) {
            this.items.last.setActive();
        }
        else {
            this.items.toArray()[currentIndex - 1].setActive();
        }
    }
    /**
     * deselects all the dropdown items
     */
    unSelectAllItems() {
        this.items.forEach((item) => {
            item.unsetActive();
        });
    }
    /**
     * removes open class from 'this._eleRef.nativeElement'
     * sets variable 'this.dropdownOpened' to false
     */
    closeDropdown() {
        this._renderer.removeClass(this._eleRef.nativeElement, "open");
        this.dropdownOpened = false;
    }
    /**
     * add open class to 'this._eleRef.nativeElement'
     * sets variable 'this.dropdownOpened' to true
     */
    openDropdown() {
        //this.unSelectAllItems();
        this._renderer.addClass(this._eleRef.nativeElement, "open");
        this.dropdownOpened = true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ButtonDropDownComponent, deps: [{ token: "data-btn-class", attribute: true }, { token: "id", attribute: true }, { token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ButtonDropDownComponent, selector: "[data-uxd-btn-ddl-cmp]", inputs: { dropdown: "dropdown", highlightFirstOption: "highlightFirstOption" }, outputs: { onChange: "onChange" }, host: { listeners: { "document:click": "onDocumentClick($event)" } }, viewQueries: [{ propertyName: "mainBtn", first: true, predicate: ["psButton"], descendants: true }, { propertyName: "items", predicate: ButtonDropdownItemDirective, descendants: true }], usesOnChanges: true, ngImport: i0, template: `<div class="dropdown-btn-wrapper"><button #psButton [id]="'psButton'+dropdown.id" (click)="onButtonClick($event)" type="button" class="btn dropdown-toggle" [attr.aria-expanded]="dropdownOpened">
                <span class="buttonMain" [innerHTML]="dropdown?.label"></span>
                <span class="fa fa-caret-down"></span>
                <span class="sr-only">Toggle Dropdown</span>
              </button>
              <div *ngIf="dropdown" #psDropdown [id]="'psDropdown'+dropdown.id" class="ant-main-div">
                <ul class="dropdown-menu" role="menu" >
                  <ng-container *ngFor="let li of dropdown.options; let i = index;">
                    <li role="menuitem">
                      <a [id]="'ddlLink'+li.id" data-dropdown-menu-item [ngClass]="{'hidden': li.showIf === false}" [attr.data-analytics] = "li.analytics" [href]="sanitizeHref(li.link)" [attr.target]="(li.targetType? li.targetType: '_self')"  (click)="onItemClick(li.value, li.title, i)" (keydown)="onItemKeydown($event, i, undefined)" >
                        <span [ngClass]="li.className"></span>
                        <span [innerHTML]="li.title"></span>
                      </a>
                    </li>
                   </ng-container>
                </ul>
              </div></div>`, isInline: true, dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ButtonDropdownItemDirective, selector: "[data-dropdown-menu-item]" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ButtonDropDownComponent, decorators: [{
            type: Component,
            args: [{
                    selector: "[data-uxd-btn-ddl-cmp]",
                    template: `<div class="dropdown-btn-wrapper"><button #psButton [id]="'psButton'+dropdown.id" (click)="onButtonClick($event)" type="button" class="btn dropdown-toggle" [attr.aria-expanded]="dropdownOpened">
                <span class="buttonMain" [innerHTML]="dropdown?.label"></span>
                <span class="fa fa-caret-down"></span>
                <span class="sr-only">Toggle Dropdown</span>
              </button>
              <div *ngIf="dropdown" #psDropdown [id]="'psDropdown'+dropdown.id" class="ant-main-div">
                <ul class="dropdown-menu" role="menu" >
                  <ng-container *ngFor="let li of dropdown.options; let i = index;">
                    <li role="menuitem">
                      <a [id]="'ddlLink'+li.id" data-dropdown-menu-item [ngClass]="{'hidden': li.showIf === false}" [attr.data-analytics] = "li.analytics" [href]="sanitizeHref(li.link)" [attr.target]="(li.targetType? li.targetType: '_self')"  (click)="onItemClick(li.value, li.title, i)" (keydown)="onItemKeydown($event, i, undefined)" >
                        <span [ngClass]="li.className"></span>
                        <span [innerHTML]="li.title"></span>
                      </a>
                    </li>
                   </ng-container>
                </ul>
              </div></div>`
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Attribute,
                    args: ["data-btn-class"]
                }] }, { type: undefined, decorators: [{
                    type: Attribute,
                    args: ["id"]
                }] }, { type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i1.DomSanitizer }]; }, propDecorators: { dropdown: [{
                type: Input
            }], highlightFirstOption: [{
                type: Input
            }], mainBtn: [{
                type: ViewChild,
                args: ["psButton"]
            }], items: [{
                type: ViewChildren,
                args: [ButtonDropdownItemDirective]
            }], onChange: [{
                type: Output,
                args: ["onChange"]
            }], onDocumentClick: [{
                type: HostListener,
                args: ["document:click", ["$event"]]
            }] } });

const EXPAND_ANIMATION_TIMING = '500ms cubic-bezier(0.4,0.0,0.2,1)';
const COLLAPSE_ANIMATION_TIMING = '250ms cubic-bezier(0.4,0.0,0.2,1)';
const dropdownAnimations = {
    dropdownPanelExpansion: trigger('expand', [
        state('collapsed', style({
            height: '0',
            display: 'none'
        })),
        state('expanded', style({
            height: '*'
        })),
        transition('expanded => collapsed', [animate(EXPAND_ANIMATION_TIMING)]),
        transition('collapsed => expanded', [style({ display: 'block' }), animate(COLLAPSE_ANIMATION_TIMING)])
    ])
};

// Unique ID, dynamically updated each time a new dropdown is created
let uuid = 0;
class DropDownComponent {
    /**
     * activeOptionRef
     * An Angular refenernce <ElementRef> to the currently active
     * element in the listbox
     */
    get activeOptionRef() {
        return this._activeOptionRef;
    }
    set activeOptionRef(option) {
        if (option && option.nativeElement) {
            this._activeOptionRef = option;
            this._activeElementId = option.nativeElement.id;
        }
    }
    get dropdownOpened() {
        return this._dropdownOpened;
    }
    set dropdownOpened(isOpened) {
        this._dropdownOpened = isOpened;
        isOpened ? this.onOpen.emit() : this.onClose.emit();
    }
    /** Returns whether the listbox is open */
    get isOpen() {
        return this.dropdownOpened;
    }
    /** A CustomValueAccessor function called whenever the NgModel changes.
     * @see https://angular.io/api/forms/ControlValueAccessor
     */
    _onChangeCallback(value) {
        /* noop -- no operation. */
    }
    /** A CustomValueAccessor function called whenever the dropdown is touched (clicked, interacted with, etc.).
     * @see https://angular.io/api/forms/ControlValueAccessor
     */
    _onTouchedCallback() {
        /* noop -- no operation. */
    }
    set defaultText(defaultText) {
        this._defaultText = defaultText;
        this._changeDetectorRef.detectChanges();
    }
    get defaultText() {
        return this._defaultText;
    }
    get id() {
        return this._id;
    }
    set id(id) {
        this._id = id;
    }
    get innerValue() {
        return this._value;
    }
    set innerValue(val) {
        this._value = val;
        this._changeDetectorRef.detectChanges();
    }
    get triggerText() {
        return this._triggerText;
    }
    set triggerText(text) {
        this._triggerText = text;
        this._changeDetectorRef.detectChanges();
    }
    /** The HTML id attribute identifying the legend  */
    get legendId() {
        return `${this._id}_legend`;
    }
    /** The HTML id attribute identifying the trigger button  */
    get buttonId() {
        return `${this.id}_button`;
    }
    /** The HTML id attribute identifying the button text.  */
    get buttonTextId() {
        return `${this.buttonId}-text`;
    }
    /** The HTML id attribute identifying the listbox  */
    get dropdownListId() {
        return `${this.id}_listbox`;
    }
    /**
     * Returns the unqiue, HTML id for a dropdown option
     * @param itemIndex the numeric index of a dropdown option
     */
    dropdownOptionId(itemIndex) {
        return `${this.id}_option-${itemIndex}`;
    }
    constructor(eleRef, _renderer, _changeDetectorRef) {
        this.eleRef = eleRef;
        this._renderer = _renderer;
        this._changeDetectorRef = _changeDetectorRef;
        /** An array of recently typed alpha- characters  */
        this._charsTyped = null;
        /** The first two letters of every option label */
        this._firstLettersList = null;
        this._activeOptionIndex = 0;
        this._dropdownOpened = false;
        this._onDestroy = new Subject();
        this._listboxAnimatingStream = new Subject();
        /** Array of IDropdownItem options that determine the value, label, and state, of individual
         * option elements. */
        this.items = [];
        this._defaultText = 'Select One';
        this.labelText = '';
        this.ariaLabelledBy = '';
        this.emitOnWrite = true;
        this.onChange = new EventEmitter();
        this.onClose = new EventEmitter();
        this.onOpen = new EventEmitter();
        this._id = `uxd-dd-${uuid++}`;
        this._charsTyped = new Array();
    }
    ngOnInit() {
        this.triggerText = this.defaultText;
        this.innerValue = this.innerValue;
    }
    ngAfterViewInit() {
        /** If a default value has been provided via the `value` input, then ensure
         * the dropdown reflects this programmed selection.*/
        // if (this.innerValue && this._activeOptionIndex) {
        //   const options = this._optionsAsArray();
        //   const defaultOption = options[this._activeOptionIndex];
        //   this._focusItem(defaultOption);
        // }
        /** When the listbox is done animating, check whether the listbox is open or closed.
         *  If the listbox is open, focus should go to the listbox.
         *
         *  This method is used because focus can only be applied after `display: none` has
         *  been removed from the listbox element. */
        this._listboxAnimatingStream
            .pipe(distinctUntilChanged(), takeUntil(this._onDestroy))
            .subscribe(() => {
            if (this.isOpen && !this.disabled) {
                this.focusOnListbox();
            }
            // Scroll the selected value into view.
            // This can only be done once the listbox has been opened fully
            const options = this._optionsAsArray();
            if (options && options.length && this.innerValue) {
                const optionEl = options[this._activeOptionIndex].nativeElement;
                this._scrollOptionIntoView(optionEl);
            }
        });
        // Grab the first two letters of every option
        this._firstLettersList = this.items.map((item) => item.label.slice(0, 2).toLocaleUpperCase());
        this._renderer.addClass(this.eleRef.nativeElement, 'uxd-btn-ddl');
    }
    ngOnChanges(changes) {
        if (typeof changes['hasError'] !== 'undefined' && changes['hasError'].currentValue === true) {
            this._renderer.addClass(this.eleRef.nativeElement, 'ant-error-state');
        }
        else {
            this._renderer.removeClass(this.eleRef.nativeElement, 'ant-error-state');
        }
    }
    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
    /**
     * Invoked when the trigger button is clicked.
     * Toggles whether the listbox is visible or hidden.
     * @param event The click event
     */
    _handleButtonClick(event) {
        if (!this.disabled) {
            this.isOpen ? this._hideListbox() : this._showListbox();
        }
    }
    /**
     * Invoked when an option is clicked (mouse or keyboard)
     * Selects the option and immediately closes the listbox
     * @param event
     * @param item
     * @param index
     */
    _handleOptionClick(event, item, index) {
        if (item.value === this._value) {
            this._hideListbox();
            this.focusOnTrigger();
            event.preventDefault();
        }
        else if (!item.disabled) {
            const options = this._optionsAsArray();
            const clickedOption = options[index];
            this.selectItem(item, true);
            this._focusItem(clickedOption);
            this._activeOptionIndex = index;
            this._hideListbox();
            this.focusOnTrigger();
            event.preventDefault();
        }
    }
    /**
     * Invoked on keydown when focus is on the button
     * Handles ARROW_UP and ARROW_DOWN functionality
     */
    _handleButtonKeydown(event) {
        const keyCode = event.which || event.keyCode;
        const options = this._optionsAsArray();
        switch (keyCode) {
            case ARROW_UP:
            case ARROW_DOWN: {
                const activeOption = options[this._activeOptionIndex];
                this._showListbox();
                this._focusItem(activeOption);
                event.preventDefault();
                break;
            }
        }
    }
    /**
     * Invoked on keydown when focus is within the listbox
     * Handles UP,LEFT,DOWN,RIGHT arrow functionality, along with
     * the press of HOME, which moves focus to and selects the first option,
     * and press of END, which moves focus to and selects the last option.
     * @param event
     */
    _handleListboxKeydown(event) {
        const keyCode = event.which || event.keyCode;
        const options = this._optionsAsArray();
        switch (keyCode) {
            case HOME: {
                /** HOME: If the listbox is displayed, moves focus to and selects the first option.  */
                const idx = this._focusFirstItem();
                this.selectItemByIndex(idx);
                event.preventDefault();
                break;
            }
            case END: {
                /** END:  If the listbox is displayed, moves focus to and selects the last option. */
                const idx = this.focusLastItem();
                this.selectItemByIndex(idx);
                event.preventDefault();
                break;
            }
            case ARROW_DOWN:
            case ARROW_RIGHT: {
                /** DOWN / RIGHT
                 * Moves focus to and selects the next option.
                 * If the listbox is collapsed, also expands the list. */
                const activeOption = options[this._activeOptionIndex];
                const nextIdx = this._activeOptionIndex + 1 <= options.length - 1 ? this._activeOptionIndex + 1 : 0;
                const nextOption = options[nextIdx];
                this._unfocusItem(activeOption);
                this._focusItem(nextOption);
                this._activeOptionIndex = nextIdx;
                this.selectItemByIndex(this._activeOptionIndex);
                event.preventDefault();
                break;
            }
            case ARROW_UP:
            case ARROW_LEFT: {
                /** UP / LEFT
                 * Moves focus to and selects the previous option.
                 * If the listbox is collapsed, also expands the list. */
                const activeOption = options[this._activeOptionIndex];
                const prevIdx = this._activeOptionIndex - 1 >= 0 ? this._activeOptionIndex - 1 : options.length - 1;
                const prevOption = options[prevIdx];
                this._unfocusItem(activeOption);
                this._focusItem(prevOption);
                this._activeOptionIndex = prevIdx;
                this.selectItemByIndex(this._activeOptionIndex);
                event.preventDefault();
                break;
            }
            case SPACE:
            case ENTER: {
                const item = this.items[this._activeOptionIndex];
                if (item.value === this._value) {
                    this._hideListbox();
                    this.focusOnTrigger();
                    event.preventDefault();
                }
                else if (!item.disabled) {
                    this._toggleOption(this.activeOptionRef, true);
                    this.selectItem(item, true);
                    this._hideListbox();
                    this.focusOnTrigger();
                    event.preventDefault();
                }
                break;
            }
            case ESCAPE: {
                this._hideListbox();
                this.focusOnTrigger();
                break;
            }
            case TAB: {
                this._hideListbox();
                break;
            }
            default: {
                //If key is alpha
                if (keyCode >= 65 && keyCode <= 90) {
                    let self = this;
                    self._charsTyped.push(String.fromCharCode(keyCode));
                    self._charsTyped = self._charsTyped.splice(0, 2);
                    let searchTerm = this._charsTyped.join('');
                    // Find the index of `searchTerm`, if it exists; otherwise, return -1
                    let index = this._firstLettersList.indexOf(searchTerm);
                    if (index >= 0) {
                        let prevSelectedItem = options[this._activeOptionIndex];
                        let selectedItem = options[index];
                        this._unfocusItem(prevSelectedItem);
                        this._focusItem(selectedItem);
                        this.selectItemByIndex(index);
                        this._activeOptionIndex = index;
                    }
                    setTimeout(() => {
                        this._charsTyped = [];
                    }, 1500);
                }
            }
        }
    }
    /**
     * Invoked when the backdrop element is clicked
     * Closes the listbox and removes the backdrop
     */
    _handleBackdropClick() {
        this._hideListbox();
        this.focusOnTrigger();
    }
    /**
     * Writes a value to the input (ControlValueAccessor).
     * Allows Angular to update the model.
     * @param value
     */
    writeValue(value) {
        if (typeof value === 'undefined') {
            return;
        }
        if (value !== this.innerValue) {
            this._selectItemByValue(value, this.emitOnWrite);
        }
    }
    /**
     * Register a function to tell Angular when the value of the input changes (ControlValueAccessor).
     * Allows Angular to register a function to call when the model changes.
     * @param fn
     */
    registerOnChange(fn) {
        this._onChangeCallback = fn;
    }
    _updateSelectedItem(value) {
        let selectedOption = this._getSelectedItem(value);
        this._emitOnChangeEvent(selectedOption);
    }
    _emitOnChangeEvent(option) {
        if (option) {
            this._onChangeCallback(option.value);
            this.onChange.emit(option);
        }
        else {
            /* Allow null/undefined values to be selected */
            this._onChangeCallback(option);
        }
    }
    /**
     * Register a function to tell Angular when the input has been touched (ControlValueAccessor).
     * Allows Angular to register a function to call when the input has been tpuched.
     * @param fn
     */
    registerOnTouched(fn) {
        this._onTouchedCallback = fn;
    }
    _isFiltered(value) {
        if (!this.filterItemValue) {
            return false;
        }
        let result = false;
        this.filterItemValue.forEach((f) => {
            if (f.toString() === value.toString()) {
                result = true;
            }
        });
        return result;
    }
    /**
     * Selects an item by finding the option with the corresponding value
     * @param value
     */
    _selectItemByValue(value, emitValue) {
        if (value === null) {
            this.triggerText = this.defaultText;
            this.innerValue = undefined;
            this._unfocusAllItems(this._optionsAsArray());
        }
        else {
            this.items.forEach((item) => {
                if (value.toString() === item.value.toString()) {
                    this.selectItem(item, emitValue);
                    return;
                }
            });
        }
    }
    /**
     * Opens the listbox, displaying the list of options
     * Adds focus immediately to the listbox element
     */
    _showListbox() {
        this.dropdownOpened = true;
    }
    /**
     * Opens the listbox, displaying the list of options
     * Returns focus to the dropdown trigger
     */
    _hideListbox() {
        this.dropdownOpened = false;
    }
    /**
     * Selects an item and calls the ControlValueAccessor
     * callback functions
     * @param item the provided IDropdownItem option
     */
    selectItem(item, emitEvent = false) {
        if (!item || item.disabled) {
            return;
        }
        if (this.innerValue === item.value) {
            return;
        }
        this.innerValue = item.value;
        this.triggerText = item.label;
        const options = this._optionsAsArray();
        const selectedIdx = this._getItemIndex(this.innerValue);
        this._focusItem(options[selectedIdx]);
        this._activeOptionIndex = selectedIdx;
        if (emitEvent) {
            this._updateSelectedItem(item.value);
        }
        this._onTouchedCallback();
    }
    /**
     * Selects an item by its index in the listbox
     */
    selectItemByIndex(idx) {
        if (!this.items || !this.items[idx]) {
            return;
        }
        const item = this.items[idx];
        this.selectItem(item, true);
    }
    /**
     * Toggles an option between selected and un-selected
     * Ensures aria attributes (aria-selected) are updated
     */
    _toggleOption(option, isSelected) {
        const element = option.nativeElement;
        const ariaSelected = isSelected ? 'true' : null;
        this._renderer.setAttribute(element, 'aria-selected', ariaSelected);
    }
    /**
     * Adds focus to the first option in the listbox
     */
    _focusFirstItem() {
        if (!this._options) {
            return null;
        }
        const options = this._optionsAsArray();
        const first = this._options.first;
        const activeOption = options[this._activeOptionIndex];
        this._focusItem(first);
        this._unfocusItem(activeOption);
        this.selectItemByIndex(this._activeOptionIndex);
        return this._activeOptionIndex;
    }
    /**
     * Adds focus to the last item in the listbox
     */
    focusLastItem() {
        if (!this._options) {
            return null;
        }
        const options = this._optionsAsArray();
        const last = this._options.last;
        const activeOption = options[this._activeOptionIndex];
        this._activeOptionIndex = this._options.length - 1;
        this._focusItem(last);
        this._unfocusItem(activeOption);
        this.selectItemByIndex(this._activeOptionIndex);
        return this._activeOptionIndex;
    }
    /** Add focus to the listbox element  */
    focusOnListbox() {
        if (!this.isOpen) {
            return;
        }
        const listbox = this._listbox && this._listbox.nativeElement;
        if (listbox) {
            listbox.focus();
        }
    }
    /** Add focus to the button/trigger element  */
    focusOnTrigger() {
        const trigger = this._trigger && this._trigger.nativeElement;
        if (trigger) {
            trigger.focus();
        }
    }
    /**
     * Returns the index of an HTML option associated with a given option value
     */
    _getItemIndex(value = '') {
        if (!value) {
            return -1;
        }
        const optionsInDOM = this.items
            .filter((item) => {
            if (item.disabled || item.hidden) {
                return false;
            }
            return true;
        })
            .map((option) => option.value);
        return optionsInDOM.indexOf(value);
    }
    /**
     * Returns the IDropdownItem associated with a given option value
     */
    _getSelectedItem(value) {
        let result = null;
        if (!value) {
            return result;
        }
        this.items.forEach((item) => {
            if (value.toString() === item.value.toString() && !item.disabled && !item.hidden) {
                result = item;
            }
        });
        return result;
    }
    /**
     * Returns the IDropdownItem associated with a given option value
     */
    _getHTMLOptionByIndex(index) {
        const options = this._optionsAsArray();
        return options[index];
    }
    /**
     * Adds relevant 'focus' class to the HTML element,
     * Ensures that a selected element appears "Focused"
     */
    _focusItem(option) {
        const element = option && option.nativeElement;
        // Remove the 'focus' class from all the elements
        this._unfocusAllItems(this._optionsAsArray());
        // Style the 'focused' element to appear to have focus.
        this._renderer.setAttribute(element, 'aria-selected', 'true');
        this._renderer.addClass(element, 'focus');
        this.activeOptionRef = option;
        // Scroll option into view
        this._scrollOptionIntoView(element);
    }
    /**
     * Removes 'focus' class from the HTML element,
     */
    _unfocusItem(option) {
        const element = option && option.nativeElement;
        // Style the 'focused' element to appear to have focus.
        this._renderer.removeAttribute(element, 'aria-selected');
        this._renderer.removeClass(element, 'focus');
    }
    /**
   * Removes 'focus' class from all HTML elements,
   */
    _unfocusAllItems(options) {
        for (let i = 0; i < options.length; i++) {
            this._unfocusItem(options[i]);
        }
    }
    /** Return the available options as an array of elements  */
    _optionsAsArray() {
        const options = this._options.toArray();
        return options;
    }
    /**
     * Ensure currently focused option element is always in view
     * @param optionElement
     */
    _scrollOptionIntoView(optionElement) {
        const listboxEl = this._listbox.nativeElement;
        if (listboxEl.scrollHeight > listboxEl.clientHeight) {
            /** the inner height of listboxEl in pixels plus the number of pixels
             *  that the content is scrolled vertically */
            const scrollBottom = listboxEl.clientHeight + listboxEl.scrollTop;
            /** The number of pixels from the top of the container plus the height of optionElement,.  */
            const elementBottom = optionElement.offsetTop + optionElement.offsetHeight;
            if (elementBottom > scrollBottom) {
                listboxEl.scrollTop = elementBottom - listboxEl.clientHeight;
            }
            else {
                listboxEl.scrollTop = optionElement.offsetTop;
            }
            return;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DropDownComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DropDownComponent, selector: "[data-uxd-dropdown-cmp]", inputs: { items: "items", defaultText: "defaultText", hasError: "hasError", labelText: "labelText", disabled: "disabled", ariaLabel: ["aria-label", "ariaLabel"], ariaLabelledBy: ["aria-labelledby", "ariaLabelledBy"], filterItemValue: "filterItemValue", emitOnWrite: "emitOnWrite", isRequired: "isRequired", describedBy: "describedBy", id: "id", dropDownType: "dropDownType", innerValue: ["value", "innerValue"] }, outputs: { onChange: "onChange", onClose: "onClose", onOpen: "onOpen" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DropDownComponent),
                multi: true
            }
        ], viewQueries: [{ propertyName: "_trigger", first: true, predicate: ["trigger"], descendants: true }, { propertyName: "_listbox", first: true, predicate: ["listbox"], descendants: true }, { propertyName: "_options", predicate: ["option"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"pfSelect\"\n  [id]=\"id\"\n  [ngClass]=\"{\n    'borderless': (dropDownType === 'borderless'),\n    'active': isOpen\n  }\">\n  <div class=\"pfSelect-legend\" [id]=\"legendId\" [innerHTML]=\"labelText\"></div>\n\n  <button\n    aria-haspopup=\"listbox\"\n    [id]=\"buttonId\"\n    #trigger\n    [attr.aria-label]=\"ariaLabel\"\n    [attr.aria-labelledby]=\"legendId + ' ' + buttonTextId + ' ' + ariaLabelledBy\"\n    [attr.aria-disabled]=\"disabled || null\"\n    [attr.aria-expanded]=\"isOpen\"\n    [attr.disabled]=\"disabled\"\n    [attr.required]=\"isRequired\"\n    [attr.aria-describedby]=\"describedBy\"\n    class=\"psButton\" type=\"button\"\n    (click)=\"_handleButtonClick($event)\"\n    (keydown)=\"_handleButtonKeydown($event)\">\n    <span [id]=\"buttonTextId\" class=\"psActiveOption\" [attr.data-text]=\"triggerText\">{{ triggerText }}</span>\n    <span class=\"psArrow\" aria-hidden=\"true\"></span>\n  </button>\n\n  <ul #listbox\n    [id]=\"dropdownListId\"\n    role=\"listbox\" tabindex=\"-1\"\n     aria-haspopup=\"listbox\"\n    [attr.aria-activedescendant]=\"_activeElementId\"\n    [attr.aria-labelledby]=\"legendId\"\n    (keydown)=\"_handleListboxKeydown($event)\"\n    class=\"psDropdown\"\n    [@expand]=\"isOpen ? 'expanded' : 'collapsed'\"\n    (@expand.done)=\"_listboxAnimatingStream.next($event)\"\n    [ngClass]=\"{'active': isOpen }\">\n\n    <ng-container *ngFor=\"let item of items; let $index = index\">\n      <li role=\"option\" class=\"psLabel\" #option\n      *ngIf=\"!item.hidden && !_isFiltered(item.value)\"\n      [id]=\"dropdownOptionId($index)\"\n      (click)=\"_handleOptionClick($event,item, $index)\"\n      [attr.data-value]=\"item.value\"\n      [attr.data-label]=\"item.label\"\n      [attr.aria-disabled]=\"item.disabled\"\n      [attr.data-analytics]=\"item.analytics ? item.analytics : null\">\n        <span [id]=\"dropdownOptionId($index) + '_text'\">{{ item.label }}</span>\n      </li>\n    </ng-container>\n\n  </ul>\n  <div tabindex=\"-1\" class=\"listbox-backdrop\" (click)=\"_handleBackdropClick()\">\n  </div>\n</div>", dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], animations: [dropdownAnimations.dropdownPanelExpansion] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DropDownComponent, decorators: [{
            type: Component,
            args: [{ selector: '[data-uxd-dropdown-cmp]', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => DropDownComponent),
                            multi: true
                        }
                    ], animations: [dropdownAnimations.dropdownPanelExpansion], template: "<div class=\"pfSelect\"\n  [id]=\"id\"\n  [ngClass]=\"{\n    'borderless': (dropDownType === 'borderless'),\n    'active': isOpen\n  }\">\n  <div class=\"pfSelect-legend\" [id]=\"legendId\" [innerHTML]=\"labelText\"></div>\n\n  <button\n    aria-haspopup=\"listbox\"\n    [id]=\"buttonId\"\n    #trigger\n    [attr.aria-label]=\"ariaLabel\"\n    [attr.aria-labelledby]=\"legendId + ' ' + buttonTextId + ' ' + ariaLabelledBy\"\n    [attr.aria-disabled]=\"disabled || null\"\n    [attr.aria-expanded]=\"isOpen\"\n    [attr.disabled]=\"disabled\"\n    [attr.required]=\"isRequired\"\n    [attr.aria-describedby]=\"describedBy\"\n    class=\"psButton\" type=\"button\"\n    (click)=\"_handleButtonClick($event)\"\n    (keydown)=\"_handleButtonKeydown($event)\">\n    <span [id]=\"buttonTextId\" class=\"psActiveOption\" [attr.data-text]=\"triggerText\">{{ triggerText }}</span>\n    <span class=\"psArrow\" aria-hidden=\"true\"></span>\n  </button>\n\n  <ul #listbox\n    [id]=\"dropdownListId\"\n    role=\"listbox\" tabindex=\"-1\"\n     aria-haspopup=\"listbox\"\n    [attr.aria-activedescendant]=\"_activeElementId\"\n    [attr.aria-labelledby]=\"legendId\"\n    (keydown)=\"_handleListboxKeydown($event)\"\n    class=\"psDropdown\"\n    [@expand]=\"isOpen ? 'expanded' : 'collapsed'\"\n    (@expand.done)=\"_listboxAnimatingStream.next($event)\"\n    [ngClass]=\"{'active': isOpen }\">\n\n    <ng-container *ngFor=\"let item of items; let $index = index\">\n      <li role=\"option\" class=\"psLabel\" #option\n      *ngIf=\"!item.hidden && !_isFiltered(item.value)\"\n      [id]=\"dropdownOptionId($index)\"\n      (click)=\"_handleOptionClick($event,item, $index)\"\n      [attr.data-value]=\"item.value\"\n      [attr.data-label]=\"item.label\"\n      [attr.aria-disabled]=\"item.disabled\"\n      [attr.data-analytics]=\"item.analytics ? item.analytics : null\">\n        <span [id]=\"dropdownOptionId($index) + '_text'\">{{ item.label }}</span>\n      </li>\n    </ng-container>\n\n  </ul>\n  <div tabindex=\"-1\" class=\"listbox-backdrop\" (click)=\"_handleBackdropClick()\">\n  </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { _trigger: [{
                type: ViewChild,
                args: ['trigger']
            }], _listbox: [{
                type: ViewChild,
                args: ['listbox']
            }], _options: [{
                type: ViewChildren,
                args: ['option']
            }], items: [{
                type: Input,
                args: ['items']
            }], defaultText: [{
                type: Input
            }], hasError: [{
                type: Input,
                args: ['hasError']
            }], labelText: [{
                type: Input,
                args: ['labelText']
            }], disabled: [{
                type: Input,
                args: ['disabled']
            }], ariaLabel: [{
                type: Input,
                args: ['aria-label']
            }], ariaLabelledBy: [{
                type: Input,
                args: ['aria-labelledby']
            }], filterItemValue: [{
                type: Input,
                args: ['filterItemValue']
            }], emitOnWrite: [{
                type: Input,
                args: ['emitOnWrite']
            }], isRequired: [{
                type: Input,
                args: ['isRequired']
            }], describedBy: [{
                type: Input,
                args: ['describedBy']
            }], onChange: [{
                type: Output,
                args: ['onChange']
            }], onClose: [{
                type: Output
            }], onOpen: [{
                type: Output
            }], id: [{
                type: Input
            }], dropDownType: [{
                type: Input,
                args: ['dropDownType']
            }], innerValue: [{
                type: Input,
                args: ['value']
            }] } });

const DROPDOWN_COMPONENT_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DropDownComponent),
    multi: true
};

class DropdownModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DropdownModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DropdownModule, declarations: [ButtonDropDownComponent, ButtonDropdownItemDirective, DropDownComponent], imports: [CommonModule], exports: [ButtonDropDownComponent, ButtonDropdownItemDirective, DropDownComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DropdownModule, providers: [DROPDOWN_COMPONENT_VALUE_ACCESSOR], imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DropdownModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [ButtonDropDownComponent, ButtonDropdownItemDirective, DropDownComponent],
                    exports: [ButtonDropDownComponent, ButtonDropdownItemDirective, DropDownComponent],
                    providers: [DROPDOWN_COMPONENT_VALUE_ACCESSOR]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ButtonDropDownComponent, ButtonDropdownItemDirective, DropDownComponent, DropdownModule };
